import React from 'react';
import { Copy } from '@cimpress/react-components';

const CodeBlockDemo = () => {
  const textToCopy = 'I will be copied into the Clipboard.';
  return (
    <div>
      <h5>Click to copy "{textToCopy}"</h5>
      <div className="row">
        <div className="col-md-4">
          <h6>Default button</h6>
          <Copy variant="button" value={textToCopy} />
        </div>

        <div className="col-md-4">
          <h6>Overridden message</h6>
          <Copy variant="button" value={textToCopy} successMessage="Yey! Copied!">
            Copy Now
          </Copy>
        </div>

        <div className="col-md-4">
          <h6>Different style</h6>
          <Copy variant="button" value={textToCopy} successMessage="Yey! Copied!">
            Copy Now
          </Copy>
        </div>
      </div>
    </div>
  );
};

export default CodeBlockDemo;
